import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	expandOrCollapseObjectType: {
		id: 'cmdb-schema-navigation.loaded.content.object-type-tree.object-type-link.expand-or-collapse-object-type',
		defaultMessage: 'Expand or collapse object type',
		description: 'Label for a button that expands or collapses an object type',
	},
});
